import $ from 'jquery';
import BasePropertyView from 'BasePropertyView.js';
import contentTemplate from 'properties/main/slider.ejs';
import { pickerCfg } from 'pickerCfg.js';
import listService from 'ListService';
import constants        from 'Constants';
import mobileSyncService from "../../../service/mobile/MobileSyncService";
import TextUtil from 'util/TextUtil.js';
class MainSliderView extends BasePropertyView {

    initialize( opts ) {
        super.initialize(opts);
        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;
        this.config = opts.config || {};
        this.events = {
            'change #mainSliderMin, #mainSliderMax': 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'change select': 'updateAttributes',
            'change input[type=color]': 'updateColorAttributes',
            'change #sliderColor' : 'updateColorAttributesWithValidation',
            'keydown input[type=text]' : 'validatePositiveNumeric'
        };

        let mobileDesignerStyle = listService.mainKind === constants.KIND_MOBILE ? "display: none;" : "";
        this.model.set('mobileDesignerStyle', mobileDesignerStyle, constants.MODEL_SILENT);

        return this;
    }

    validatePositiveNumeric(ev){
        TextUtil.validatePositiveNumeric(ev);
    }

    updateAttributes(event){
        event.preventDefault();

        let value = event.currentTarget.value;
        let name = event.currentTarget.name;

        switch (name){
            case 'minValue':
                value = value === '' ? 0 : parseInt(value); 
                const max = parseInt(this.model.get('maxValue'));
                if(value > max){
                    value = max;
                    event.currentTarget.value = max;
                }
                break;
            case 'maxValue':
                value = value === '' ? 0 : parseInt(value); 
                const min = parseInt(this.model.get('minValue'));
                if(value < min){
                    value = min;
                    event.currentTarget.value = min;
                }
                break;
        }

        this.model.set(name, value, constants.MODEL_SILENT);
        this.updateScale();
        mobileSyncService.synchronizeMobileForm(this.model, this.model.get('factoryKey'), {key: name, val: value });

        this.render();
    }

    updateScale(){
        var stepLength = parseInt(this.model.get('stepLength'));
        const max = parseInt(this.model.get('maxValue'));
        const min = parseInt(this.model.get('minValue'));
        var scaleLength = parseInt(max) - parseInt(min);
        var unitDistance = 100 / scaleLength;
        var finalDistance = unitDistance * stepLength;
        var steps = scaleLength / stepLength;
        this.model.set('steps', steps);
        this.model.set('distance', finalDistance);
    }



    render() {
        super.render(); //Related to PF-2097 - Forms/Reports - Asset issue, color reseting. Spectrum component implemented on slider main settings.
        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));

        if (this.config.showTitle) {
            this.$el.find('.propTitle').removeClass('hide');
        }

        $('#mainSliderSnap').find('option[value=' + this.model.get('snapInterval') +']').attr('selected', true);

        this.delegateEvents();
        return this;
    }


}

export default MainSliderView;
